module.exports = __webpack_public_path__ + "static/media/poo-storm.99c7b98f.svg";